import React, { createContext, useContext, useState, useEffect } from 'react';
import * as authAPI from '../services/operations/authAPI';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [authChecked, setAuthChecked] = useState(false);
  const [user, setUser] = useState(null);

  // Check auth status on mount
  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const res = await authAPI.checkAuth();
      if (res && res.success) {
        setIsLoggedIn(true);
        setUser(res.user || null);
      } else {
        setIsLoggedIn(false);
        setUser(null);
      }
    } catch (err) {
      setIsLoggedIn(false);
      setUser(null);
    } finally {
      setAuthChecked(true);
    }
  };

  const login = async (userData) => {
    // Set logged in immediately to update UI, then populate user details.
    setIsLoggedIn(true);
    if (userData) {
      setUser(userData);
    } else {
      // If no user data provided, refresh auth state from server to get user object
      try {
        await checkAuth();
      } catch (err) {
        // If checkAuth fails, ensure we don't leave a stale logged-in flag
        setIsLoggedIn(false);
        setUser(null);
      }
    }
  };

  const logout = async () => {
    // Call server to clear auth cookie, then clear client state
    try {
      await authAPI.logout();
    } catch (err) {
      console.error('Logout API error', err);
    } finally {
      setIsLoggedIn(false);
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, user, login, logout, checkAuth, authChecked }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext); 